import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

// External
import { AngularFireDatabase } from 'angularfire2/database';
import * as lodash from 'lodash';
import { Order } from './../../models/order'

@Component({
    templateUrl: './order.detail.component.html'
})
export class OrderDetailComponent {
    offerKey: string;
    orderKey: string;
    public orderData = {
        club:{
            name :"GOlfhubber",
            city: "london",
            state :"ECA",
            postCode:"1CA",
            country:"UK",
        }
    };
    public OrderDetails=[
        {
            VoucherId:"GH-21-1111",
            OrderID:"GOLFHUBBER-20000",
            VoucherName:"GOLFHUBBER",
            quantity:"2",
            payment:{
                amount:"100"
            },
        },
        {
            VoucherId:"GH-21-1111",
            OrderID:"GOLFHUBBER-20000",
            VoucherName:"GOLFHUBBER",
            quantity:"2",
            payment:{
                amount:"100"
            },
        },
        {
            VoucherId:"GH-21-1111",
            OrderID:"GOLFHUBBER-20000",
            VoucherName:"GOLFHUBBER",
            quantity:"2",
            payment:{
                amount:"100"
            },
        },
        {
            VoucherId:"GH-21-1111",
            OrderID:"GOLFHUBBER-20000",
            VoucherName:"GOLFHUBBER",
            quantity:"2",
            payment:{
                amount:"100"
            },
        },
    ]

    constructor(private route: ActivatedRoute, private location: Location, private fireDatabase: AngularFireDatabase) {

        this.offerKey = this.route.snapshot.paramMap.get('offerKey');
        this.orderKey = this.route.snapshot.paramMap.get('orderKey');
        if (!this.offerKey) {
            return;
        }

        this.fireDatabase.object(`/offer-orders/${this.offerKey}/${this.orderKey}`)
            .subscribe((result) => {

                this.orderData = result;
                console.log(result);

                this.fireDatabase.object(`users/${result.club.clubId}`)
                    .subscribe((club) => {
                        this.orderData.club = club
                    })

            }, error => {
                console.error(error);
            });

    }



}
